'use client';

import { Box, Link, List, ListItem } from '@mui/material';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import { usePathname } from 'next/navigation';
import { ContactIcon } from '@components/SVGIcon/Icons';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import DynamicLogo from '@components/DynamicLogo';
import DynamicDrawer from '@components/DynamicDrawer';
import MobileNavigation from './MobileNavigation';
import CommonDynamicButton from '../CommonDynamicButton';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';
export default function WestminsterTowerHeader(props: any) {
  const pathname = usePathname();
  const headerNavigationLeft =
    props?.locale?.section?.westminsterTowerNavigationLeft;
  const headerNavigationRight =
    props?.locale?.section?.westminsterTowerNavigationRight;
  const isActiveLink = (href?: string) => {
    if (!href) return false;
    if (href.startsWith('#')) {
      if (typeof window === 'undefined') return false;
      return window.location.hash === href;
    }
    if (!pathname) return false;
    const pathSegments = pathname.split('/');
    const hrefSegments = href.split('/');
    const lastPathSegment = pathSegments[pathSegments.length - 1];
    const lastHrefSegment = hrefSegments[hrefSegments.length - 1];
    if (lastPathSegment === lastHrefSegment) return true;
    if (lastPathSegment === 'thejubilee' && lastHrefSegment === 'theresidences')
      return true;
    return false;
  };
  return (
    <DynamicScrollHeader
      headerClassName={cn.westminsterTowerHeader}
      scrolledClassName={cn.westminsterHeaderScrolled}
    >
      <Box className={cn.westminsterHeaderInner}>
        <Desktop>
          <Box className={cn.westminsterHeaderLogo}>
            <Link
              href="/properties/en/westminstertower"
              className={cn.westminsterLogoElement}
            >
              <DynamicLogo
                logoImage={props?.images?.westminster_tower_logo_light?.src}
                alt="Westminster Tower Logo"
              />
            </Link>
          </Box>
        </Desktop>
        <Box className={cn.westminsterHeaderBlock}>
          <Mobile>
            <Box className={cn.westminsterDrawerNavigation}>
              <DynamicDrawer
                drawerClassName={cn.westminsterTowerDrawer}
                drawerBodyClassName={cn.westminsterTowerDrawerBody}
                drawerContentClassName={cn.westminsterTowerDrawerContent}
                closeBtnClassName={cn.westminsterTowerDrawerClose}
                buttonClassName={cn.westminsterTowerDrawerButton}
              >
                <MobileNavigation {...props} />
              </DynamicDrawer>
            </Box>
          </Mobile>
          <Desktop>
            <Box className={cn.westminsterNavigationLeft}>
              <List className={cn.westminsterNavigationList}>
                {Array.isArray(headerNavigationLeft) &&
                  headerNavigationLeft.map((item: any, index: number) => (
                    <ListItem
                      key={index}
                      className={cn.westminsterNavigationItem}
                    >
                      <Link
                        href={item?.url}
                        className={`${cn.westminsterNavigationLink} ${
                          item?.className ? cn[item.className] : ''
                        } ${isActiveLink(item?.url) ? cn.activeLink : ''}`}
                      >
                        {item?.label}
                      </Link>
                    </ListItem>
                  ))}
              </List>
            </Box>
          </Desktop>
          <Mobile>
            <Box className={cn.westminsterHeaderLogo}>
              <Link
                href="/properties/en/westminstertower"
                className={cn.westminsterLogoElement}
              >
                <DynamicLogo
                  logoImage={props?.images?.westminster_tower_logo_light?.src}
                  alt="Westminster Tower Logo"
                />
              </Link>
            </Box>
          </Mobile>
          <Box className={cn.westminsterNavigationRight}>
            <Desktop>
              <List className={cn.westminsterNavigationList}>
                {Array.isArray(headerNavigationRight) &&
                  headerNavigationRight.map((item: any, index: number) => (
                    <ListItem
                      key={index}
                      className={cn.westminsterNavigationItem}
                    >
                      <Link
                        href={item?.url}
                        className={`${cn.westminsterNavigationLink} ${
                          item?.className ? cn[item.className] : ''
                        } ${isActiveLink(item?.url) ? cn.activeLink : ''}`}
                      >
                        {item?.label}
                      </Link>
                    </ListItem>
                  ))}
              </List>
            </Desktop>
            <Box className={cn.westminsterNavigationButton}>
              <Mobile>
                <DynamicButton
                  className={cn.westminsterNavigationButton__element}
                  scrollToId="westminsterTowerRegistrationID"
                >
                  <span>
                    <ContactIcon />
                  </span>
                </DynamicButton>
              </Mobile>
              <Desktop>
                <CommonDynamicButton
                  label={
                    props.locale.section['westminsterTowerNavigationButton'] ||
                    'contact'
                  }
                  scrollToId="westminsterTowerRegistrationID"
                  className={cn.westminsteHeaderBtn}
                  elementClassName={cn.westminsteHeaderBtnElement}
                />
              </Desktop>
            </Box>
          </Box>
        </Box>
      </Box>
    </DynamicScrollHeader>
  );
}
